<ng-content select="[icn-navbar-menu-header]"></ng-content>
<div
  class="menu"
  [hidden]="!active"
  [style.width]="overrideWidth"
  [ngClass]="{ animateOut: animateOut }"
>
  <ng-content select="[icn-navbar-menu-items]"></ng-content>
</div>
